import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import forSize from '../../views/ProvideSize';

import { providers } from '../../store/spottingGroupDrilldown/spottingGroupDrilldownReducers';

const mapStateToProps = (state = {}) => ({
  ...state.users,
  ...state.spottingGroupDrilldown,
  ...state.modelSpottingGroup,
});

const mapDispatchToProps = dispatch => Object.keys(providers)
  .reduce((dispatcher, name) => ({ ...dispatcher, [name]: (...args) => dispatch(providers[name](...args)) }), {});

export default item => connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(forSize(item)));
